import { useLocalSearchParams } from 'expo-router';
import { useEffect } from 'react';
import useAuthStore from '@/stores/useAuthStore';
import useJoinIntentStore, { type JoinKind } from '@/stores/useJoinIntentStore';
import normalizeInviteCode from '@/utils/normalizeInviteCode';
import Join from '.';

export default function JoinRoute({ kind }: { kind: JoinKind }) {
  const { code } = useLocalSearchParams<{
    code?: string;
  }>();
  const authStatus = useAuthStore((state) => state.status);
  const clearJoinIntent = useJoinIntentStore((state) => state.clearJoinIntent);
  const joinIntent = useJoinIntentStore((state) => state.joinIntent);
  const normalizedCode = normalizeInviteCode(code || '');

  useEffect(() => {
    if (authStatus !== 'in' || normalizedCode.length !== 8 || !joinIntent) {
      return;
    }

    clearJoinIntent();
  }, [authStatus, clearJoinIntent, joinIntent, normalizedCode]);

  if (authStatus !== 'in') return null;

  return <Join kind={kind} />;
}
